class RouteUtil {
  static getLocationParameter(props, parameterName, defaultValue = undefined) {
    var parameter =
      props?.location?.state?.[parameterName] !== undefined
        ? props.location.state[parameterName]
        : defaultValue;

    parameter =
      parameter === defaultValue &&
      props?.location?.[parameterName] !== undefined
        ? props.location[parameterName]
        : parameter;

    return parameter;
  }

  static getHistoryLocationParameter(
    props,
    parameterName,
    defaultValue = undefined
  ) {
    return this.getLocationParameter(
      props.history,
      parameterName,
      defaultValue
    );
  }

  static locationParameterExists(props, parameterName) {
    const exists = props.location?.state?.[parameterName] !== undefined;
    return exists;
  }

  static getAndDeleteLocationParameter(
    props,
    parameterName,
    shouldUpdateLocation = true,
    defaultValue = undefined
  ) {
    const parameter = this.getLocationParameter(
      props,
      parameterName,
      defaultValue
    );

    if (parameter !== defaultValue) {
      var state = props.location.state ? props.location.state : props.location;

      if (state && state[parameterName]) {
        delete state[parameterName];

        if (shouldUpdateLocation) {
          props.history.replace(props.location.pathname, { ...state });
        }
      }
    }

    return parameter;
  }

  static getAndDeleteHistoryLocationParameter(
    props,
    parameterName,
    shouldUpdateLocation = true,
    defaultValue = undefined
  ) {
    const parameter = this.getHistoryLocationParameter(
      props,
      parameterName,
      defaultValue
    );

    if (parameter !== defaultValue) {
      var state = props.location.state ? props.location.state : props.location;

      if (state && state[parameterName]) {
        delete state[parameterName];

        if (shouldUpdateLocation) {
          props.history.replace(props.location.pathname, { ...state });
        }
      }
    }

    return parameter;
  }

  static changeLocationParameters(
    props,
    newParameters,
    shouldUpdateLocation = true
  ) {
    var state = props.location.state !== undefined ? props.location.state : {};

    if (newParameters) {
      for (var i = 0; i < newParameters.length; i++) {
        const newParameter = newParameters[i];
        state[newParameter.parameterName] = newParameter.newValue;
      }

      if (shouldUpdateLocation) {
        props.history.replace(props.location.pathname, { ...state });
      }
    }
  }

  static changeHistoryLocationParameters(
    props,
    newParameters,
    shouldUpdateLocation = true
  ) {
    this._changeLocationParameters(
      props,
      props.history.location,
      newParameters,
      shouldUpdateLocation
    );
  }

  static _changeLocationParameters(
    props,
    location,
    newParameters,
    shouldUpdateLocation = true
  ) {
    var state = location.state !== undefined ? location.state : {};

    if (newParameters) {
      for (var i = 0; i < newParameters.length; i++) {
        const newParameter = newParameters[i];
        state[newParameter.parameterName] = newParameter.newValue;
      }

      if (shouldUpdateLocation) {
        props.history.replace(location.pathname, { ...location, ...state });
      }
    }
  }
}

export default RouteUtil;
